module.exports = __webpack_public_path__ + "static/media/agricultural11.8d546197.jpg";